/*
 * Confidential and Proprietary.
 * Do not distribute without Bloom Harbor Gifts consent.
 * Copyright Bloom Harbor Gifts 2019. All rights reserved.
 */

import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators, compose } from 'redux';
import {
    object, func, bool, array, shape, string,
} from 'prop-types';

import withStyles from '@material-ui/core/styles/withStyles';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';

import * as recipientFormActions from '../../../../../../../../state/ducks/Recipient/ducks/RecipientForm/RecipientForm-Actions';

import QasAddressVerificationModal from '../../QasAddressVerification/QasAddressVerificationModal/QasAddressVerificationModal';
import AddressVerificationSearch from '../../../../Common/AddressVerificationSearch/AddressVerificationSearch';
import GoogleAddressSearch from '../../../../Common/GoogleAddressSearch/GoogleAddressSearch';

import TextFieldWrapper from '../../TextFieldWrapper/TextFieldWrapper';
import withValidation from '../../TextFieldWrapper/ValidationHOC';
import InlineErrorMessage from '../../ErrorMessage/InlineErrorMessage';

import States from '../../../../../constants/states';
import FieldProperties from '../../../Shipping/Partials/DeliveryForm/Helper/FieldProperties';
import { defaultCountryList } from '../../../../../constants/country';
import {
    getHasQasFailed, getRecipientFormError, getShowValidatedAddressSuggestion,
} from '../../../../../../../../state/ducks/Common/Common-Selectors';

import { addAddressBook, editAddressBook } from '../../../../../../../../state/ducks/Member/ducks/AddressBook/AddressBook-Actions';

import * as qasAddressSearchActions from '../../../../../../../../state/ducks/Common/ducks/AddressSearchQAS/AddressSearchQAS-Actions';
import { getFeatureFlags } from '../../../../../../../../state/ducks/App/ducks/Config/Config-Selectors';
import { removeMaskForPhoneNumber } from '../../TextFieldWrapper/Helper/Helper';
import LoqateAddressVerificationSearch from '../../../../Common/LoqateAddressVerificationSearch/LoqateAddressVerificationSearch';

const styles = (theme) => ({
    formContent: {
        paddingRight: '2px',
        fontSize: '16px',
    },
    inputWrapper: {
        marginBottom: '10px',
    },
    paddingLeft5px: {
        paddingLeft: '5px',
    },
    paddingRight5px: {
        paddingRight: '5px',
    },
    btnEnabled: {
        color: theme.palette.white,
        backgroundColor: theme.palette.primaryButton,
        fontSize: '15px',
        textAlign: 'center',
        width: '240px',
        height: 'auto',
        padding: '4px 0',
        margin: '0 auto',
        display: 'block',
        boxShadow: 'none',
        textTransform: 'none',
        '&:hover, &:focus': {
            backgroundColor: theme.palette.primaryButton,
            color: theme.palette.white,
        },
        '&$btnDisabled': {
            backgroundColor: theme.palette.colorNeutral60,
            color: theme.palette.white,
        },
    },
    btnCancel: {
        backgroundColor: theme.palette.white,
        color: theme.palette.cms?.primary || theme.palette.colorPrimary,
        fontSize: '15px',
        textAlign: 'center',
        width: '240px',
        height: 'auto',
        padding: '10px 0',
        margin: '0 auto',
        display: 'block',
        boxShadow: 'none',
        textDecoration: 'underline',
        textTransform: 'none',
        '&:hover, &:focus': {
            backgroundColor: theme.palette.white,
            color: theme.palette.cms?.primary || theme.palette.colorPrimary,
        },
    },
    btnDisabled: {
        backgroundColor: theme.palette.colorNeutral60,
        color: theme.palette.white,
    },
    textInfo: {
        fontSize: '16px',
    },
    addressBookForm: {
        minWidth: '100%',
    },
});

const initState = {
    locationType: {
        required: true,
        flagError: false,
        errorMessage: '',
    },
    firstName: {
        required: true,
        flagError: false,
        errorMessage: '',
    },
    lastName: {
        required: true,
        flagError: false,
        errorMessage: '',
    },
    organizationName: {
        required: false,
        flagError: false,
        errorMessage: '',
    },
    address1: {
        required: true,
        flagError: false,
        errorMessage: '',
    },
    address2: {
        required: false,
        flagError: false,
        errorMessage: '',
    },
    city: {
        required: true,
        flagError: false,
        errorMessage: '',
    },
    state: {
        required: true,
        flagError: false,
        errorMessage: '',
    },
    zipCode: {
        required: true,
        flagError: false,
        errorMessage: '',
    },
    country: {
        required: false,
        flagError: false,
        errorMessage: '',
    },
    phone: {
        required: true,
        flagError: false,
        errorMessage: '',
    },
};

class AddressBookForm extends Component {
    constructor(props) {
        super(props);

        this.state = {
            formFieldValues: {},
            formValid: false,
            addressSearch: {
                focus: false,
                valueOnKeyUp: '',
            },
        };

        this.formTransition = {
            locationType: {
                Business: {
                    organizationName: {
                        label: 'Company Name',
                    },
                },
                POBox: {
                    address1: {
                        label: 'P.O. Box',
                    },
                    address2: {
                        label: 'Apartment/Suite/Other',
                    },
                },
                APOFPO: {
                    address1: {
                        label: 'Unit/Ship/PSC Number',
                    },
                    address2: {
                        label: 'Box/Hull Number',
                    },
                },
                /*
                FuneralHome: {
                    firstName: {
                        label: 'First Name of Deceased',
                    },
                    lastName: {
                        label: 'Last Name of Deceased',
                    },
                    organizationName: {
                        label: 'Name of Funeral Home',
                    },
                },
                Hospital: {
                    organizationName: {
                        label: 'Hospital Name',
                    },
                },
                School: {
                    organizationName: {
                        label: 'School Name',
                    },
                },
                Church: {
                    organizationName: {
                        label: 'Church Name',
                    },
                }, */
            },
            country: {
                US: {
                    state: {
                        label: 'State',
                        dropdownData: States.US,
                    },
                    zipCode: {
                        label: 'Zip Code',
                        max: 5,
                        inputType: 'AlphaNumeric',
                        inputFieldType: 'tel', // set input type="tel" for numberic keyboard to appear mobile (tel type is needed for iphone)
                    },
                },
                CA: {
                    state: {
                        label: 'Province',
                        dropdownData: States.CA,
                    },
                    zipCode: {
                        label: 'Postal Code',
                        max: 6,
                        inputType: 'AlphaNumeric',
                        inputFieldType: 'text',
                    },
                },
                USA: {
                    state: {
                        label: 'State',
                        dropdownData: States.US,
                    },
                    zipCode: {
                        label: 'Zip Code',
                        max: 5,
                        inputType: 'AlphaNumeric',
                        inputFieldType: 'tel', // set input type="tel" for numberic keyboard to appear mobile (tel type is needed for iphone)
                    },
                },
                CAN: {
                    state: {
                        label: 'Province',
                        dropdownData: States.CA,
                    },
                    zipCode: {
                        label: 'Postal Code',
                        max: 6,
                        inputType: 'AlphaNumeric',
                        inputFieldType: 'text',
                    },
                },
            },
        };
    }

    componentDidMount() {
        const { actionsQasAddress } = this.props;
        this.updateValueForm();

        // clear address verification state
        actionsQasAddress.resetQasAddressState();
    }

    updateValueForm = () => {
        const { bookAddressValues } = this.props;
        let formValid = false;
        let formFieldValues = {
            entryId: '',
            addressId: '',
            firstName: '',
            lastName: '',
            address1: '',
            address2: '',
            locationType: 'Residence',
            organizationName: '',
            state: '',
            country: 'US',
            zipCode: '',
            phone: '',
            city: '',
        };
        if (bookAddressValues?.firstName) {
            formFieldValues = {
                entryId: bookAddressValues.addressBookEntryId,
                addressId: bookAddressValues.addressId || bookAddressValues.addressBookEntryId,
                firstName: this.cleanString(bookAddressValues.firstName),
                lastName: this.cleanString(bookAddressValues.lastName),
                address1: this.cleanString(bookAddressValues.addressLineOne),
                address2: this.cleanString(bookAddressValues.addressLineTwo?.substring(0, 30)),
                locationType: this.cleanString(bookAddressValues.addressType || 'Residence'),
                organizationName: this.cleanString(bookAddressValues.employerName),
                state: this.cleanString(bookAddressValues.state),
                country: this.cleanString(bookAddressValues.country || 'USA'),
                zipCode: bookAddressValues.zip,
                phone: this.cleanString(bookAddressValues.phoneNumber),
                city: this.cleanString(bookAddressValues.city),
            };
            formValid = true;
        }

        this.setState({ formFieldValues, formValid });
    }

    // isAddressVerified: U - Unverified || V - Verified || O - Overwrite
    proceedSubmitAddressBook = async (actionType, dpvIndicator = 'N', isAddressVerified = 'U', overWriteAddress) => {
        const {
            handleAddAddressBook, handleEditAddressBook, handleCancelAddressBookForm, flags,
            proceedSaveBookAddressPwaDesktop, showAddressValidation, hasQasFailed,
        } = this.props;
        const {
            formValid, formFieldValues, deliveryFormValidate,
        } = this.state;

        if (formValid) {
            const reqObj = {
                recipient: {
                    ...formFieldValues,
                },
                dpvIndicator,
                isAddressVerified,
            };

            const formRecipientValues = {
                firstName: formFieldValues.firstName,
                lastName: formFieldValues.lastName,
                employerName: formFieldValues.organizationName || '',
                relationShip: '',
                phoneNumber: formFieldValues.phone,

                addressType: formFieldValues.locationType,
                addressLineOne: formFieldValues.address1,
                addressLineTwo: formFieldValues.address2?.substring(0, 30),
                city: formFieldValues.city,
                state: formFieldValues.state,
                zip: formFieldValues.zipCode,
                country: formFieldValues.country,
                isBillingAddress: false,
                addressBookRecipientId: '',
                addressStatus: isAddressVerified,
                dpvIndicator,
            };
            if ((flags['is-qas-address-verification-enabled'] && !hasQasFailed) || flags['is-gnav-lq-enabled']) {
                if (actionType === 'qasAddressSelection') {
                    formRecipientValues.addressLineOne = overWriteAddress.addressLine1;
                    formRecipientValues.addressLineTwo = overWriteAddress.addressLine2;
                    formRecipientValues.city = overWriteAddress.city;
                    formRecipientValues.country = overWriteAddress.country;
                    formRecipientValues.state = overWriteAddress.state;
                    formRecipientValues.zip = overWriteAddress.zipcode;
                    if (formFieldValues.entryId) {
                        formRecipientValues.addressBookEntryId = formFieldValues.entryId;
                        handleEditAddressBook(formRecipientValues);
                    } else {
                        handleAddAddressBook(formRecipientValues);
                    }
                    handleCancelAddressBookForm();
                } else if (actionType === 'keep') {
                    if (formFieldValues.entryId) {
                        formRecipientValues.addressBookEntryId = formFieldValues.entryId;
                        handleEditAddressBook(formRecipientValues);
                    } else {
                        handleAddAddressBook(formRecipientValues);
                    }

                    if (formValid) {
                        handleCancelAddressBookForm();
                    }
                } else if (actionType === 'save') {
                    proceedSaveBookAddressPwaDesktop(reqObj);
                    if (showAddressValidation) {
                        handleCancelAddressBookForm();
                    }
                }
            } else {
                proceedSaveBookAddressPwaDesktop(reqObj);
            }
        } else {
            this.setState({ deliveryFormValidate: !deliveryFormValidate });
        }
    }

    formFieldRule = (event) => {
        const { formFieldState, updateFormFieldState } = this.props;
        const { formFieldValues } = this.state;
        const updateFieldState = { ...formFieldState };
        const { name, value } = event.target;

        if (name === 'locationType') {
            if (value === 'Business') {
                updateFieldState.organizationName.required = true;
            } else if (value === 'APO/FPO') {
                updateFieldState.address2.required = true;
                updateFieldState.city.required = true;
                updateFieldState.state.required = true;
                updateFieldState.organizationName.required = false;
            } else {
                updateFieldState.organizationName.required = false;
                updateFieldState.organizationName.flagError = false;
                updateFieldState.organizationName.errorMessage = '';
                updateFieldState.organizationName.alert = false;
                updateFieldState.address2.required = false;
                updateFieldState.address2.flagError = false;
                updateFieldState.address2.errorMessage = '';
                updateFieldState.city.required = true;
                updateFieldState.city.errorMessage = '';
                this.handleFormStateChanges('country', formFieldValues.country);
            }
        } else if (name === 'country') {
            if (value === 'US' || value === 'CA') {
                updateFieldState.state.required = true;
                updateFieldState.zipCode.required = true;
            } else {
                updateFieldState.state.required = false;
                updateFieldState.state.flagError = false;
                updateFieldState.state.errorMessage = '';
                updateFieldState.zipCode.required = false;
                updateFieldState.zipCode.flagError = false;
                updateFieldState.zipCode.errorMessage = '';
            }
        }
        updateFormFieldState(updateFieldState, ['address1', 'address2'], formFieldValues, false);
    }

    handleFieldBlur = (fieldName, response) => {
        const { handleOnBlur } = this.props;
        const { formFieldValues } = this.state;
        handleOnBlur(fieldName, response, formFieldValues, null, this.updateFormStatus);
    }

    handleFieldChange = (event, response) => {
        const { handleOnBlur } = this.props;
        const { formFieldValues } = this.state;
        const fieldName = event.target.name;
        const fieldValue = event.target.value;

        const changeFormFieldValues = {
            ...formFieldValues,
        };
        changeFormFieldValues[fieldName] = event.target.value;

        this.setState({ formFieldValues: changeFormFieldValues });

        if (fieldName && fieldValue && response) {
            handleOnBlur(fieldName, response, changeFormFieldValues, null, this.updateFormStatus);
        }
    }

    handleFieldFocus = (event) => {
        if (event.target.name === 'address1') {
            const updateState = { ...this.state };
            updateState.addressSearch.focus = true;
            updateState.addressSearch.valueOnKeyUp = event.target.value;
            this.setState(updateState);
        }
    }

    handleAddressSearchBlur = () => {
        const updateState = { ...this.state };
        updateState.addressSearch.focus = false;
        updateState.addressSearch.valueOnKeyUp = '';
        this.setState(updateState);
    }

    handleOnKeyUp = (event) => {
        if (event.target.name === 'address1') {
            const updateState = { ...this.state };
            updateState.addressSearch.valueOnKeyUp = event.target.value;
            this.setState(updateState);
        }
    }

    updateFormStatus = (data) => {
        this.setState({ formValid: data });
    }

    cleanString = (str) => {
        const strVal = str || '';
        return strVal.trim();
    }

    preFillAddressDetailsRecipientQAS = async (data) => {
        const { validateFormFields } = this.props;
        const { formFieldValues } = this.state;
        const updateRecipientForm = {
            ...formFieldValues,
            address1: data.addressLine1,
            address2: data.addressLine2?.substring(0, 30),
            city: data.city,
            state: data.state,
            country: data.country,
            zipCode: data.zipcode,
        };
        this.setState({ formFieldValues: updateRecipientForm });
        const fieldsToValidate = ['address1', 'address2', 'city', 'state', 'country', 'zipCode'];
        validateFormFields(fieldsToValidate, updateRecipientForm, false);
        this.updateFormStatus(true);
    }

    renderStates = (country) => {
        let countrySel = country;
        if (countrySel === 'USA' || countrySel === 'CAN') {
            countrySel = country.slice(0, -1);
        }

        if (countrySel && States[countrySel]) {
            return Object.keys(States[countrySel]).map((state) => ({
                key: state,
                value: States[countrySel][state],
            }));
        }
        return [];
    }

    renderCountries = () => defaultCountryList.map((country) => (country));

    renderLocationTypes = () => {
        const locationTypes = Object.keys(FieldProperties);
        return locationTypes.map((location) => ({
            key: location,
            value: location,
        }));
    }

    useQasAddressSearch = () => {
        const { flags, hasQasFailed } = this.props;
        if (flags['is-qas-address-suggestions-enabled'] && !hasQasFailed) {
            return true;
        }
        return false;
    }

    useGoogleAddressSearch = () => {
        const { flags, hasQasFailed } = this.props;
        const { formFieldValues } = this.state;
        if (flags['is-google-places-enabled']
        || (flags['is-qas-address-suggestions-enabled'] && hasQasFailed && this.isUsaOrCanada(formFieldValues.country))) {
            return true;
        }
        return false;
    }

    useLoqateAddressSearch = () => {
        const { flags, hasQasFailed } = this.props;
        const { formFieldValues } = this.state;
        if ((flags['is-gnav-lq-enabled'] && this.isUsaOrCanada(formFieldValues.country))) {
            return true;
        }
        return false;
    }

    isUsaOrCanada = (country) => ['US', 'CA', 'USA', 'CAN'].includes(country);

    render() {
        const {
            classes, formFieldState, getTextFieldProps,
            error, handleCancelAddressBookForm, flags,
        } = this.props;
        const { formFieldValues, addressSearch, formValid } = this.state;

        const selCountry = formFieldValues.country || 'US';
        const formTransitionCountry = this.formTransition.country[selCountry] || {};
        const isCountryUSAorCanada = this.isUsaOrCanada(selCountry);
        const fieldlblProp = FieldProperties[formFieldValues.locationType] ? FieldProperties[formFieldValues.locationType].formFields : FieldProperties.Residence.formFields;
        const showLoqate = this.useLoqateAddressSearch();
        const showGoogle = !showLoqate && this.useGoogleAddressSearch();
        const showQas = !showLoqate && this.useQasAddressSearch() && isCountryUSAorCanada;

        return (
            <form name="addressBookForm" className={classes.addressBookForm}>
                {
                    (flags['is-qas-address-verification-enabled'] || flags['is-gnav-lq-enabled'])
                    && (
                        <QasAddressVerificationModal
                            handleSaveAddress={this.proceedSubmitAddressBook}
                            typeData="popup"
                            formFieldValues={formFieldValues}
                        />
                    )
                }
                <Grid container className={classes.formContent}>
                    <Grid xs={6} item className={`${classes.inputWrapper} ${classes.paddingRight5px}`}>
                        <TextFieldWrapper
                            customInput
                            label={fieldlblProp.firstName}
                            name="firstName"
                            inputType="Alphabets"
                            flagError={formFieldState.firstName.flagError}
                            errorMessage={formFieldState.firstName.errorMessage}
                            required={formFieldState.firstName.required}
                            variant="outlined"
                            val={formFieldValues.firstName}
                            max={200}
                            isInputFilled={this.handleFieldBlur}
                            setTextInputState={this.handleFieldChange}
                            returnFieldProps={getTextFieldProps}
                            autoComplete="section-shipping given-name"
                        />
                    </Grid>
                    <Grid xs={6} item className={`${classes.inputWrapper} ${classes.paddingLeft5px}`}>
                        <TextFieldWrapper
                            customInput
                            label={fieldlblProp.lastName}
                            name="lastName"
                            inputType="Alphabets"
                            flagError={formFieldState.lastName.flagError}
                            errorMessage={formFieldState.lastName.errorMessage}
                            required={formFieldState.lastName.required}
                            variant="outlined"
                            val={formFieldValues.lastName}
                            max={200}
                            isInputFilled={this.handleFieldBlur}
                            setTextInputState={this.handleFieldChange}
                            returnFieldProps={getTextFieldProps}
                            autoComplete="section-shipping family-name"
                        />
                    </Grid>
                    <Grid xs={12} item className={classes.inputWrapper}>
                        <TextFieldWrapper
                            customSelect
                            label={fieldlblProp.locationType}
                            name="locationType"
                            inputType="Alphabets"
                            flagError={formFieldState.locationType.flagError}
                            errorMessage={formFieldState.locationType.errorMessage}
                            required={formFieldState.locationType.required}
                            variant="outlined"
                            dropdown={this.renderLocationTypes()}
                            val={formFieldValues.locationType}
                            max={200}
                            isInputFilled={this.handleFieldBlur}
                            setTextInputState={this.handleFieldChange}
                            returnFieldProps={getTextFieldProps}
                        />
                    </Grid>
                    {!!(fieldlblProp.organizationName)
                    && (
                        <Grid xs={12} item className={classes.inputWrapper}>
                            <TextFieldWrapper
                                customInput
                                label={fieldlblProp.organizationName}
                                name="organizationName"
                                inputType="AlphaNumeric"
                                flagError={formFieldState.organizationName.flagError}
                                errorMessage={formFieldState.organizationName.errorMessage}
                                required={formFieldState.organizationName.required}
                                variant="outlined"
                                val={formFieldValues.organizationName}
                                max={200}
                                isInputFilled={this.handleFieldBlur}
                                setTextInputState={this.handleFieldChange}
                                returnFieldProps={getTextFieldProps}
                            />
                        </Grid>
                    )}
                    <Grid item xs={12} className={classes.inputWrapper}>
                        {/* Address Search - Google Start */}
                        {(showGoogle)
                            && (
                                <GoogleAddressSearch
                                    getPreFillAddressDetails={this.preFillAddressDetailsRecipientQAS}
                                    searchId="addressbook-address-line1"
                                >
                                    <TextFieldWrapper
                                        customInput
                                        label={fieldlblProp.address1}
                                        id="addressbook-address-line1"
                                        key="recipientAddressSearchTF"
                                        name="address1"
                                        inputType="AlphaNumericSpecial"
                                        fullWidth
                                        required={formFieldState.address1.required}
                                        flagError={formFieldState.address1.flagError}
                                        errorMessage={formFieldState.address1.errorMessage}
                                        val={formFieldValues.address1}
                                        max={100}
                                        isInputFilled={this.handleFieldBlur}
                                        setTextInputState={this.handleFieldChange}
                                        returnFieldProps={getTextFieldProps}
                                        autoComplete="section-shipping address-line1"
                                        infoHelpText="DELIVERY NOTES: GIFTS CANNOT BE DELIVERED TO P.O. BOXES OR APO INSTALLATIONS."
                                    />
                                </GoogleAddressSearch>
                            )}
                        {/* Address Search - Google End */}
                        {/* Address Verification Search - QAS Start */}
                        {(showQas)
                            && (
                                <AddressVerificationSearch
                                    searchId="addressbook-address-line1"
                                    searchText={addressSearch.valueOnKeyUp}
                                    searchTextFocus={addressSearch.focus}
                                    onBlurHandler={this.handleAddressSearchBlur}
                                    getPreFillAddressDetails={this.preFillAddressDetailsRecipientQAS}
                                    useGeoLocation={flags['is-qas-geo-location-enabled']}
                                    zipCode={formFieldValues.zipCode}
                                    isValidZipCode={!(error.zipCode || formFieldState.zipCode.flagError)}
                                    state={formFieldValues.state}
                                    countryCode={formFieldValues.country}
                                >
                                    <TextFieldWrapper
                                        customInput
                                        label={fieldlblProp.address1}
                                        id="addressbook-address-line1"
                                        key="recipientAddressSearchTF"
                                        name="address1"
                                        inputType="AlphaNumericSpecial"
                                        fullWidth
                                        required={formFieldState.address1.required}
                                        flagError={formFieldState.address1.flagError}
                                        errorMessage={formFieldState.address1.errorMessage}
                                        val={formFieldValues.address1}
                                        max={100}
                                        handleOnFocus={this.handleFieldFocus}
                                        handleOnKeyUp={this.handleOnKeyUp}
                                        isInputFilled={this.handleFieldBlur}
                                        setTextInputState={this.handleFieldChange}
                                        returnFieldProps={getTextFieldProps}
                                        autoComplete="section-shipping address-line1"
                                        infoHelpText="DELIVERY NOTES: GIFTS CANNOT BE DELIVERED TO P.O. BOXES OR APO INSTALLATIONS."
                                    />
                                </AddressVerificationSearch>
                            )}
                        {/* Address Verification Search - QAS End */}
                        {/* Address Verification Search - Loqate Start */}
                        {(showLoqate)
                            && (
                                <LoqateAddressVerificationSearch
                                    searchId="addressbook-address-line1"
                                    searchText={addressSearch.valueOnKeyUp}
                                    searchTextFocus={addressSearch.focus}
                                    onBlurHandler={this.handleAddressSearchBlur}
                                    getPreFillAddressDetails={this.preFillAddressDetailsRecipientQAS}
                                    useGeoLocation={flags['is-qas-geo-location-enabled']}
                                    zipCode={formFieldValues.zipCode}
                                    isValidZipCode={!(error.zipCode || formFieldState.zipCode.flagError)}
                                    state={formFieldValues.state}
                                    countryCode={formFieldValues.country}
                                >
                                    <TextFieldWrapper
                                        customInput
                                        label={fieldlblProp.address1}
                                        id="addressbook-address-line1"
                                        key="recipientAddressSearchTF"
                                        name="address1"
                                        inputType="AlphaNumericSpecial"
                                        fullWidth
                                        required={formFieldState.address1.required}
                                        flagError={formFieldState.address1.flagError}
                                        errorMessage={formFieldState.address1.errorMessage}
                                        val={formFieldValues.address1}
                                        max={100}
                                        handleOnFocus={this.handleFieldFocus}
                                        handleOnKeyUp={this.handleOnKeyUp}
                                        isInputFilled={this.handleFieldBlur}
                                        setTextInputState={this.handleFieldChange}
                                        returnFieldProps={getTextFieldProps}
                                        autoComplete="section-shipping address-line1"
                                        infoHelpText="DELIVERY NOTES: GIFTS CANNOT BE DELIVERED TO P.O. BOXES OR APO INSTALLATIONS."
                                    />
                                </LoqateAddressVerificationSearch>
                            )}
                        {/* Address Verification Search - Loqate End */}
                        {(!flags['is-google-places-enabled'] && !flags['is-qas-address-suggestions-enabled'] && !flags['is-gnav-lq-enabled'])
                            && (
                                <TextFieldWrapper
                                    customInput
                                    label={fieldlblProp.address1}
                                    id="addressbook-address-line1"
                                    key="recipientAddressSearchTF"
                                    name="address1"
                                    inputType="AlphaNumericSpecial"
                                    fullWidth
                                    required={formFieldState.address1.required}
                                    flagError={formFieldState.address1.flagError}
                                    errorMessage={formFieldState.address1.errorMessage}
                                    val={formFieldValues.address1}
                                    max={100}
                                    isInputFilled={this.handleFieldBlur}
                                    setTextInputState={this.handleFieldChange}
                                    returnFieldProps={getTextFieldProps}
                                    autoComplete="section-shipping address-line1"
                                    infoHelpText="DELIVERY NOTES: GIFTS CANNOT BE DELIVERED TO P.O. BOXES OR APO INSTALLATIONS."
                                />
                            )}
                        {(error.address1 && !formFieldState.address1.flagError)
                            && <InlineErrorMessage error={error.address1} />}
                    </Grid>
                    <Grid xs={12} item className={classes.inputWrapper}>
                        <TextFieldWrapper
                            customInput
                            label={fieldlblProp.address2}
                            name="address2"
                            inputType="AlphaNumericSpecial"
                            flagError={formFieldState.address2.flagError}
                            errorMessage={formFieldState.address2.errorMessage}
                            required={formFieldState.address2.required}
                            variant="outlined"
                            val={formFieldValues.address2}
                            max={30}
                            isInputFilled={this.handleFieldBlur}
                            setTextInputState={this.handleFieldChange}
                            returnFieldProps={getTextFieldProps}
                            autoComplete="section-shipping address-line2"
                        />
                    </Grid>
                    {
                        isCountryUSAorCanada
                        && (
                            <Grid item xs={6} className={`${classes.inputWrapper} ${classes.paddingRight5px}`}>
                                <TextFieldWrapper
                                    customInput
                                    label={formTransitionCountry.zipCode.label}
                                    name="zipCode"
                                    inputType={formTransitionCountry.zipCode.inputType}
                                    inputFieldType={formTransitionCountry.zipCode.inputFieldType}
                                    validateRule="ZipCode"
                                    required={formFieldState.zipCode.required}
                                    flagError={formFieldState.zipCode.flagError}
                                    errorMessage={formFieldState.zipCode.errorMessage}
                                    val={(/(-)/g.test(String(formFieldValues.zipCode))) ? formFieldValues.zipCode.split('-')[0] : formFieldValues.zipCode}
                                    max={formTransitionCountry.zipCode.max}
                                    isInputFilled={this.handleFieldBlur}
                                    setTextInputState={this.handleFieldChange}
                                    returnFieldProps={getTextFieldProps}
                                    autoComplete="section-shipping postal-code"
                                />
                                {(error.zipCode && !formFieldState.zipCode.flagError)
                                && <InlineErrorMessage error={error.zipCode} />}
                            </Grid>
                        )
                    }
                    <Grid xs={6} item className={`${classes.inputWrapper} ${classes.paddingRight5px}`}>
                        <TextFieldWrapper
                            customInput
                            label={fieldlblProp.city}
                            name="city"
                            inputType="Alphabets"
                            flagError={formFieldState.city.flagError}
                            errorMessage={formFieldState.city.errorMessage}
                            required={formFieldState.city.required}
                            variant="outlined"
                            val={formFieldValues.city}
                            max={200}
                            isInputFilled={this.handleFieldBlur}
                            setTextInputState={this.handleFieldChange}
                            returnFieldProps={getTextFieldProps}
                            autoComplete="section-shipping address-level2"
                        />
                    </Grid>
                    <Grid xs={6} item className={`${classes.inputWrapper} ${classes.paddingLeft5px}`}>
                        <TextFieldWrapper
                            // select
                            customSelect
                            label={fieldlblProp.state}
                            name="state"
                            inputType="Alphabets"
                            flagError={formFieldState.state.flagError}
                            errorMessage={formFieldState.state.errorMessage}
                            required={formFieldState.state.required}
                            variant="outlined"
                            dropdown={this.renderStates(formFieldValues.country || 'US') || {}}
                            val={formFieldValues.state}
                            max={200}
                            isInputFilled={this.handleFieldBlur}
                            setTextInputState={this.handleFieldChange}
                            returnFieldProps={getTextFieldProps}
                            autoComplete="section-shipping address-level1"
                        />
                    </Grid>
                    <Grid item xs={6} className={`${classes.inputWrapper} ${classes.paddingLeft5px}`}>
                        <TextFieldWrapper
                            customSelect
                            label="Country"
                            name="country"
                            defaultValue={defaultCountryList[0]}
                            required={formFieldState.country.required}
                            flagError={formFieldState.country.flagError}
                            errorMessage={formFieldState.country.errorMessage}
                            val={formFieldValues.country || 'US'}
                            dropdown={this.renderCountries()}
                            isInputFilled={this.handleFieldBlur}
                            setTextInputState={this.handleFieldChange}
                            returnFieldProps={getTextFieldProps}
                            autoComplete="section-shipping country"
                        />
                    </Grid>
                    <Grid xs={12} item className={classes.inputWrapper}>
                        <TextFieldWrapper
                            customInput
                            label={fieldlblProp.phone}
                            name="phone"
                            flagError={formFieldState.phone.flagError}
                            errorMessage={formFieldState.phone.errorMessage}
                            required={formFieldState.phone.required}
                            variant="outlined"
                            inputFieldType="tel" // set input type="tel" for numberic keyboard to appear mobile (tel type is needed for iphone)
                            inputType="Phone"
                            maskInput="Phone"
                            validateRule="Phone"
                            val={formFieldValues.phone}
                            min={10}
                            max={15}
                            isInputFilled={this.handleFieldBlur}
                            setTextInputState={this.handleFieldChange}
                            returnFieldProps={getTextFieldProps}
                            autoComplete="section-shipping tel"
                        />
                    </Grid>
                    <Grid xs={12} item className={classes.inputWrapper}>
                        <Button
                            variant="contained"
                            classes={{
                                root: classes.btnEnabled,
                                disabled: classes.btnDisabled,
                            }}
                            onClick={() => this.proceedSubmitAddressBook('save')}
                            disabled={!formValid || removeMaskForPhoneNumber(formFieldValues?.phone)?.length < 10}
                        >
                            Save
                        </Button>
                    </Grid>
                    <Grid xs={12} item className={classes.inputWrapper}>
                        <Button
                            variant="contained"
                            classes={{
                                root: classes.btnCancel,
                            }}
                            onClick={handleCancelAddressBookForm}
                        >
                            Cancel
                        </Button>
                    </Grid>
                </Grid>
            </form>
        );
    }
}

AddressBookForm.propTypes = {
    classes: object.isRequired,
    bookAddressValues: object.isRequired,
    formFieldState: shape({
        locationType: {
            required: bool,
            flagError: bool,
            errorMessage: string,
        },
        firstName: {
            required: bool,
            flagError: bool,
            errorMessage: string,
        },
        lastName: {
            required: bool,
            flagError: bool,
            errorMessage: string,
        },
        organizationName: {
            required: bool,
            flagError: bool,
            errorMessage: string,
        },
        address1: {
            required: bool,
            flagError: bool,
            errorMessage: string,
        },
        address2: {
            required: bool,
            flagError: bool,
            errorMessage: string,
        },
        city: {
            required: bool,
            flagError: bool,
            errorMessage: string,
        },
        state: {
            required: bool,
            flagError: bool,
            errorMessage: string,
        },
        zipCode: {
            required: bool,
            flagError: bool,
            errorMessage: string,
        },
        country: {
            required: bool,
            flagError: bool,
            errorMessage: string,
        },
        phone: {
            required: bool,
            flagError: bool,
            errorMessage: string,
        },
    }).isRequired,
    handleOnBlur: func.isRequired,
    handleAddAddressBook: func.isRequired,
    handleEditAddressBook: func.isRequired,
    proceedSaveBookAddressPwaDesktop: func.isRequired,
    handleCancelAddressBookForm: func.isRequired,
    getTextFieldProps: func.isRequired,
    updateFormFieldState: func.isRequired,
    flags: object.isRequired,
    actionsQasAddress: func.isRequired,
    error: object.isRequired,
    validateFormFields: func.isRequired,
    showAddressValidation: bool.isRequired,
    hasQasFailed: bool.isRequired,
};

const mapStateToProps = (state) => ({
    flags: getFeatureFlags(state),
    error: getRecipientFormError(state),
    showAddressValidation: getShowValidatedAddressSuggestion(state),
    hasQasFailed: getHasQasFailed(state),
});

const mapDispatchToProps = (dispatch) => ({
    recipientAction: bindActionCreators(recipientFormActions, dispatch),
    actionsQasAddress: bindActionCreators(qasAddressSearchActions, dispatch),
    handleAddAddressBook: bindActionCreators(addAddressBook, dispatch),
    handleEditAddressBook: bindActionCreators(editAddressBook, dispatch),
    proceedSaveBookAddressPwaDesktop: bindActionCreators(qasAddressSearchActions.proceedSaveBookAddressPwaDesktop, dispatch),
});

const AddressBookFormValidation = withValidation(AddressBookForm, initState);

export default compose(
    withStyles(styles),
    connect(mapStateToProps, mapDispatchToProps),
)(AddressBookFormValidation);
